if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomController = null;
        this.preventPointerHide = false;
        this.addEventListener('pointerup', this.onPointerUpCapture.bind(this), true);
      }

      getZoomController() {
        if (this.zoomController) return this.zoomController;
        if (!window.ProductMediaModalZoom?.getController) return null;

        this.zoomController = window.ProductMediaModalZoom.getController(this);
        return this.zoomController;
      }

      onPointerUpCapture(event) {
        if (event.pointerType !== 'mouse') return;
        if (event.target.closest('[id^="ModalClose-"]')) return;
        if (event.target.closest('deferred-media, product-model')) return;
        this.preventPointerHide = true;
      }

      hide(...args) {
        if (this.preventPointerHide) {
          this.preventPointerHide = false;
          return;
        }

        this.getZoomController()?.onHide?.();
        super.hide(...args);
      }

      show(opener) {
        this.preventPointerHide = false;
        super.show(opener);
        this.showActiveMedia();
        this.getZoomController()?.onShow?.(this.openedBy?.getAttribute('data-media-id'));
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container && typeof activeMedia.clientWidth === 'number') {
          container.scrollLeft = Math.max((activeMedia.clientWidth - container.clientWidth) / 2, 0);
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
